// Token storage. The normal session token persists across tabs/restarts
// (localStorage). An impersonation token is deliberately kept in
// sessionStorage only -- there is no server-side revocation for it, so a
// closed tab must reliably end exposure. Never move it to localStorage.

const SESSION_TOKEN_KEY = 'remindloop_token'
const IMPERSONATION_TOKEN_KEY = 'remindloop_impersonation_token'

export function getSessionToken(): string | null {
  return localStorage.getItem(SESSION_TOKEN_KEY)
}

export function setSessionToken(token: string): void {
  localStorage.setItem(SESSION_TOKEN_KEY, token)
}

export function clearSessionToken(): void {
  localStorage.removeItem(SESSION_TOKEN_KEY)
}

export function getImpersonationToken(): string | null {
  return sessionStorage.getItem(IMPERSONATION_TOKEN_KEY)
}

export function setImpersonationToken(token: string): void {
  sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token)
}

export function clearImpersonationToken(): void {
  sessionStorage.removeItem(IMPERSONATION_TOKEN_KEY)
}

/** Whichever token should be used for API calls right now. */
export function getEffectiveToken(): string | null {
  return getImpersonationToken() ?? getSessionToken()
}

export function clearAllTokens(): void {
  clearSessionToken()
  clearImpersonationToken()
}
